import axios from "axios";

import { MatterListItemDto } from "./dto";
import { MatterListItem } from "./models";
import { mapMatterListItemFromDto } from "./mappers";

import { apiClient } from "@shared/http/apiClient";
import { ApiResponse } from "@shared/http/types";

export class MatterError extends Error {}

function toMatterError(error: unknown): MatterError {
  if (!axios.isAxiosError(error)) {
    return new MatterError("Couldn't load matters.");
  }

  if (!error.response) {
    return new MatterError("Can't reach the server. Check your internet connection and try again.");
  }

  return new MatterError(
    `Couldn't load matters (${error.response.status}). Try again in a moment.`
  );
}

export async function getMatters(perPage: number = 100): Promise<MatterListItem[]> {
  let response;
  try {
    response = await apiClient.get<ApiResponse<MatterListItemDto[]>>("/v1/outlook/matters", {
      params: { per_page: perPage },
    });
  } catch (error) {
    throw toMatterError(error);
  }

  return response.data.payload.content.map(mapMatterListItemFromDto);
}
